import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppInformationService, AuthService, GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { Setting } from 'app/core/model/entity-model';
import moment from 'moment';

@Component({
    selector: 'app-status-update-dialog',
    templateUrl: './status-update-dialog.component.html',
    styleUrls: ['./status-update-dialog.component.scss'],
    standalone: false
})
export class StatusUpdateDialogComponent implements OnInit, AfterViewInit {
    result: Subject<any> = new Subject<any>();
    dueDateValue: Date;
    buildDueDateValue: Date;
    noteValue: any;
    statusIdValue: any;
    deliveryValue: any;
    statusOptions: any[];
    deliveryOptions: any;

    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    processing = false;

    @ViewChild('inputComponent') inputComponent: any;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, public auth: AuthService) { }

    async ngOnInit() {
        this.deliveryOptions = this.uow.lookups.deliveryOptions;
        this.statusOptions = this.uow.lookups.orderLineStatuses
            .filter((x) => {
                return x.name !== 'Built';
            })
            .map((x) => {
                return {
                    id: x.id,
                    name: x.name,
                };
            });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.inputComponent.instance.focus();
        });
    }

    inputRequired = (e) => {
        return this.statusIdValue || this.deliveryValue || this.dueDateValue || this.buildDueDateValue;
    };

    async setDueDate() {
        const leadTime = ((await this.uow.getSettingsByName('LeadTime')) as Setting).intValue;
        this.dueDateValue = moment().add(leadTime, 'days').toDate();
    }

    async setBuildDueDate() {
        const leadTime = ((await this.uow.getSettingsByName('LeadTime')) as Setting).intValue;
        this.buildDueDateValue = moment().add(leadTime, 'days').toDate();
    }

    save() {
        this.processing = true;
        if (!this.validate()) {
            this.processing = false;
            return;
        }
        this.result.next({ success: true, statusId: this.statusIdValue, delivery: this.deliveryValue, noteValue: this.noteValue, dueDate: this.dueDateValue, buildDue: this.buildDueDateValue });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    cancel() {
        this.result.next({ success: false });
    }
}
